import { IconIsolationMode } from 'assets/img';
import type { Column } from 'react-table';
import {
  BoxAction,
  BoxIcon,
  Cell,
  DateTimeCell,
  Header,
} from 'shared/components/planner/common/utils';
import { TFunctionNonStrict } from 'i18next';
import { CandidatePlacementsCellWithTooltip } from 'shared/components/planner/shifts/placements-tooltip/candidate-placements-cell-with-tooltip';
import {
  TableShiftPlanningCellProp,
  TableShiftPlanningColumnDefinition,
} from '../shift-planning-table.types';
import { MultiDayShiftJobNameCell } from '../components/multi-day-shift-job-name-cell';

const getTableShiftPlanningColumnDefinition: (
  t: TFunctionNonStrict<'ogp-screen-specific', undefined>
) => Column<TableShiftPlanningColumnDefinition>[] = (t) => {
  const jobName = {
    Header: () => (
      <Header>{t('planning.table_headers.job_title', { ns: 'ogp-screen-specific' })}</Header>
    ),
    accessor: 'jobName',
    Cell: MultiDayShiftJobNameCell,
    width: '200px',
  } as Column<TableShiftPlanningColumnDefinition>;
  const jobType = {
    Header: () => (
      <Header>{t('planning.table_headers.job_type', { ns: 'ogp-screen-specific' })}</Header>
    ),
    accessor: 'jobTypeName',
    Cell,
    width: '200px',
  } as Column<TableShiftPlanningColumnDefinition>;

  const departmentName = {
    Header: () => (
      <Header>{t('planning.table_headers.department', { ns: 'ogp-screen-specific' })}</Header>
    ),
    accessor: 'departmentName',
    Cell: Cell,
    width: '350px',
  } as Column<TableShiftPlanningColumnDefinition>;
  const dateTime = {
    Header: () => (
      <Header>{t('planning.table_headers.date_time', { ns: 'ogp-screen-specific' })}</Header>
    ),
    accessor: 'dateTime',
    Cell: DateTimeCell,
    width: '230px',
  } as Column<TableShiftPlanningColumnDefinition>;
  const state = {
    Header: () => (
      <Header>{t('planning.table_headers.status', { ns: 'ogp-screen-specific' })}</Header>
    ),
    accessor: 'state',
    Cell: ShiftStateCell,
    width: '100px',
  } as Column<TableShiftPlanningColumnDefinition>;
  const action = {
    Header: () => (
      <Header>{t('planning.table_headers.action', { ns: 'ogp-screen-specific' })}</Header>
    ),
    accessor: 'action',
    Cell: ActionCell,
    width: '65px',
  } as Column<TableShiftPlanningColumnDefinition>;

  return [jobName, jobType, departmentName, dateTime, state, action];
};

const ActionCell = (props: TableShiftPlanningCellProp<'action'>) => {
  return (
    <BoxAction>
      <BoxIcon>
        <IconIsolationMode onClick={() => props.onShowDetail(props.value)} />
      </BoxIcon>
    </BoxAction>
  );
};

const ShiftStateCell = (props: TableShiftPlanningCellProp<'state'>) => {
  return <CandidatePlacementsCellWithTooltip {...props} />;
};

export { getTableShiftPlanningColumnDefinition as getShiftPlanningColumnDefinition };
